// audit-recheck-EditWheel-2611032038 (T4.3, Kelly 2026-10-07: "closing the
// segment panel makes ... most segment title pills vanishing").
//
// MEASURED live web-stg.iyuga.net main.5097532b.js, /builder/510945 at
// 1440x900 Chromium: click a pill, press "Close segment" (the X at ~833,131)
// and keep the pointer still. The panel closes, the wheel grows 344 -> 732 px
// and the "Alpha" pill slides UNDER the parked pointer. The browser then fires
// a layout-induced `mouseover` on that pill (no pointer movement at all), the
// hover isolation hides every other pill (inactiveOpacity 0) and the wheel
// shows 1/8 pills until the user happens to move the mouse.
//
// A hover the user made always comes with pointer movement: the boundary
// event (mouseover) is dispatched BEFORE the `mousemove` at the new position,
// so at mouseover time the last recorded mousemove is somewhere else. When
// the mouseover arrives at exactly the last mousemove position, the pointer
// did not move — the content moved under it — and it must not isolate.

let last = null;
let installed = false;

const record = (e) => {
  last = { x: e.clientX, y: e.clientY };
};

/** Idempotent: one capture-phase listener per document. */
export function installPointerTracker(doc = typeof document !== "undefined" ? document : null) {
  if (installed || !doc || !doc.addEventListener) return;
  installed = true;
  doc.addEventListener("mousemove", record, { capture: true, passive: true });
}

/**
 * True when `event` (a mouseover/mouseenter) was caused by the content moving
 * under a stationary pointer rather than by the user moving the pointer.
 * Unknown pointer history (no mousemove seen yet) -> false (normal hover).
 */
export function isStationaryPointerHover(event) {
  if (!last || !event || typeof event.clientX !== "number") return false;
  return event.clientX === last.x && event.clientY === last.y;
}

/** Test hook. */
export function __resetPointerTracker() {
  last = null;
}
